// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	

    let itemsMenu = document.querySelectorAll('.primary-navigation .primary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
		scrollDownAction(40, 'scroll');
	};

	//for Menus
	let menu_tab = document.querySelectorAll('.menu-restaurant__tabs li');
	if (menu_tab) {
		menu_tab.forEach((element,i) => {
			
			element.addEventListener('click', _ => {
				menu_tab.forEach(b => b.classList.remove('active'));
				element.classList.add('active');
	
				document.querySelectorAll('.menu__unitmenu').forEach(menu => {
					menu.classList.remove('active');
					if ( element.dataset.tag === menu.dataset.tag ) {
						menu.classList.add('active');
					}
				});
			});
	
			if (i === 0) element.click();
		});
	}

	//Lbx
	let elements = document.querySelectorAll('[data-fancybox="accommodations"]');

	elements.forEach(function(element) {
		if (!element.hasAttribute('data-lbx-group')) {
			element.setAttribute('data-lbx-group', 'accommodations');
		}
		if (!element.hasAttribute('data-lbx-full')) {
			element.setAttribute('data-lbx-full', '');
		}
	});

	document.addEventListener('DOMContentLoaded', function() {
		var select = document.getElementById('menu-select__tabs');
		var suitesItems = document.querySelectorAll('.menu__unitmenu');

		if (select && suitesItems.length > 0) {
			suitesItems[0].classList.add('active');
		
			select.addEventListener('change', function() {
				var selectedValue = select.value;
		
				suitesItems.forEach(function(item) {
					var dataTag = item.getAttribute('data-tag');
					
					if (dataTag === selectedValue) {
						item.classList.add('active');
					} else {
						item.classList.remove('active');
					}
				});
			});
		}
	});

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	document.addEventListener('DOMContentLoaded', function() {
		var menuJs = document.getElementById('menu-js');
		var header = document.getElementById('header');
		var headerMenuNav = document.querySelector('.header__menu--nav');
		var headerMenuClose = document.querySelector('.header__menu--close');
		var headerMenuBtn = document.querySelector('.header__menu--btn');
	
		menuJs.addEventListener('click', function() {
			header.classList.add('active');
			headerMenuNav.classList.add('active');
			headerMenuClose.classList.add('show');
			menuJs.classList.add('hide');
		});
	
		headerMenuClose.addEventListener('click', function() {
			header.classList.remove('active');
			headerMenuNav.classList.remove('active');
			headerMenuBtn.classList.remove('hide');
			headerMenuClose.classList.remove('show');
		});
	});

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 40){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}